import React, { Component } from "react";
import { connect } from "react-redux";
import StyledHeader from "../../styles/StyledHeader";

class Header extends Component {
  render() {
    return (
      <StyledHeader>
        <div className="brand">
          <h1>DARRELL TEO</h1>
        </div>
      </StyledHeader>
    );
  }
}

function mapStateToProps(state = {}) {
  const { navbar } = state;
  return { navbar };
}

export default connect(mapStateToProps)(Header);



// WEBPACK FOOTER //
// ./src/components/header/Header.js